import Vue from 'vue'
import Vuex from 'vuex'
import xingshan from './modules/xingshan'
import newYear from './modules/newYear'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    xingshan,
    newYear
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js